var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F7E8E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9889 26.6604L14.4689 25.1404C13.8489 24.5204 13.8489 23.5004 14.4689 22.8804L15.9889 21.3604C16.2489 21.1004 16.4589 20.5904 16.4589 20.2304V18.0804C16.4589 17.2004 17.1789 16.4804 18.0589 16.4804H20.2089C20.5689 16.4804 21.0789 16.2704 21.3389 16.0104L22.8589 14.4904C23.4789 13.8704 24.4989 13.8704 25.1189 14.4904L26.6389 16.0104C26.8989 16.2704 27.4089 16.4804 27.7689 16.4804H29.9189C30.7989 16.4804 31.5189 17.2004 31.5189 18.0804V20.2304C31.5189 20.5904 31.7289 21.1004 31.9889 21.3604L33.5089 22.8804C34.1289 23.5004 34.1289 24.5204 33.5089 25.1404L31.9889 26.6604C31.7289 26.9204 31.5189 27.4304 31.5189 27.7904V29.9403C31.5189 30.8203 30.7989 31.5404 29.9189 31.5404H27.7689C27.4089 31.5404 26.8989 31.7504 26.6389 32.0104L25.1189 33.5304C24.4989 34.1504 23.4789 34.1504 22.8589 33.5304L21.3389 32.0104C21.0789 31.7504 20.5689 31.5404 20.2089 31.5404H18.0589C17.1789 31.5404 16.4589 30.8203 16.4589 29.9403V27.7904C16.4589 27.4204 16.2489 26.9104 15.9889 26.6604Z",
    stroke: "#CE623E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27L27 21",
    stroke: "#CE623E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4945 26.5H26.5035",
    stroke: "#CE623E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4945 21.5H21.5035",
    stroke: "#CE623E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f8c6f25e0c2595fdb30904974974987a.svg";
export { ForwardRef as ReactComponent };